<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    children: Snippet;
  };

  const { children }: Props = $props();
</script>

<div class="text-white uppercase !mt-0 !text-[1rem] h6">{@render children()}</div>
